export default __webpack_public_path__ + "static/media/logo.23941f58.png";